var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"has-text-centered"},[_vm._v(_vm._s(_vm.item.contest.title))]),_c('td',{staticClass:"has-text-centered hidden-print"},[_c('router-link',{staticClass:"button is-small",attrs:{"to":{
        name: 'marketing.contests.edit',
        params: { uuid: _vm.item.contest.uuid },
      }}},[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-pencil"})])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }